import React from "react";
import styles from "./ProductCard.module.sass";

import Card from "../ui/Card/Card";

import carIcon from "../../assets/veiculo.svg";
import houseIcon from "../../assets/imovel.svg";
import gaTags from "../../utils/ga-tags";
const NOT_SPECIFIED = "Não Especificada"

const productCard = props => {
  const icon = parseInt(props.product.id) === 1 ? houseIcon : carIcon;
  const title = parseInt(props.product.id) === 1 ? "Imobiliário" : "Veículo";

  const gaTypeName = `${gaTags.type}EcolhaDoBem-Botão`;

  const allClasses = [styles.ProductCard, gaTags.class];
  if (props.selected) {
    allClasses.push(styles.selected);
  }
  if (props.grayScale) {
    allClasses.push(styles.grayScale);
  }

  return (
    <div
      onClick={event => {
        props.clicked(props.product);
        window.dataLayer.push({
          event: "datalayereventos",
          gacategory:
            event.target.getAttribute("data-gacategory") || NOT_SPECIFIED,
          gatype:
            event.target.getAttribute("data-gatype") || NOT_SPECIFIED,
          gafunc: event.target.getAttribute("data-gafunc") || NOT_SPECIFIED
        });
        if (props.hasOwnProperty("onClick")){
           props.onClick(event);
        }
      }}
      className={allClasses.join(" ")}
      data-category={gaTags.categoryDefault}
      data-gatype={gaTypeName}
      data-gafunc={
        title === "Imóvel" ? `${gaTypeName}-Imovel` : `${gaTypeName}-Veiculo`
      }
    >
      <Card grayScale={props.grayScale} selected={props.selected}>
        <p className={styles.title}>{title}</p>
        <img
          alt={props.product.nome}
          className={styles.ProductIcon}
          src={icon}
        />
      </Card>
      <div className={styles.cardFooter}>
        <a className={styles.link} href="/">
          Escolher
        </a>
      </div>
    </div>
  );
};

export default productCard;
